// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_QjbLL","swiper":"swiper_tXkc-","item":"item_AFAGK","link":"link_3LBno","title":"title_6pwSi","img":"img_vWY4v"};